import * as Yup from 'yup';
import moment from 'moment';
import editCompanyFormModel from './editCompanyFormModel';
const {
  formField: {
    e_type_document,
    e_number_document,
    e_tradename,
    e_business_name,
    e_legal_representative,
    e_email,
    e_manager_in_charge,
    e_economic_activity,
    e_branch_offices,
    e_country,
    e_departament,
    e_municipaly,
    e_address_company,
    e_workplace,
    e_landline,
    e_cell_phone,

    // ARCHIVOS
    e_rut,
    e_chamber_of_commerce,
    e_bank_certificate,

    // FORMA DE PAGO
    e_payment_frequency,
    e_payment_method,
    e_associated_bank,
    e_type_account_bank,
    e_account_number,

    // SEGURIDAD SOCIAL
    e_sgsst,
    e_arl,
    e_constitution_date,
    e_ley_1429_2010,
    e_ley_590_2000,
    e_ley_1607_2012,
  },
} = editCompanyFormModel;

export default [
  // INFORMACION BASICA
  Yup.object().shape({
    [e_type_document.name]: Yup.object()
      .shape({
        value: Yup.string().required(),
        label: Yup.string().required(),
      })
      .default(undefined) // 👈
      .required(`${e_type_document.requiredErrorMsg}`),

    [e_number_document.name]: Yup.number()
      .typeError('Documento debe ser numerico')
      .label(`${e_number_document.typeDataMsg}`)
      .required(`${e_number_document.requiredErrorMsg}`),
    [e_tradename.name]: Yup.string().required(`${e_tradename.requiredErrorMsg}`),
    [e_business_name.name]: Yup.string().required(`${e_business_name.requiredErrorMsg}`),
    [e_legal_representative.name]: Yup.string().required(
      `${e_legal_representative.requiredErrorMsg}`
    ),
    [e_email.name]: Yup.string()
      .required(`${e_email.requiredErrorMsg}`)
      .email(`${e_email.requiredErrorMsg}`),
    [e_manager_in_charge.name]: Yup.string().required(`${e_manager_in_charge.requiredErrorMsg}`),
    [e_economic_activity.name]: Yup.object()
      .shape({
        value: Yup.string().required(),
        label: Yup.string().required(),
      })
      .default(undefined) // 👈
      .required(`${e_economic_activity.requiredErrorMsg}`),
    [e_country.name]: Yup.object()
      .shape({
        value: Yup.string().required(),
        label: Yup.string().required(),
      })
      .default(undefined) // 👈
      .required(`${e_country.requiredErrorMsg}`),
    [e_departament.name]: Yup.object()
      .shape({
        value: Yup.string().required(),
        label: Yup.string().required(),
      })
      .default(undefined) // 👈
      .required(`${e_departament.requiredErrorMsg}`),
    [e_municipaly.name]: Yup.object()
      .shape({
        value: Yup.string().required(),
        label: Yup.string().required(),
      })
      .default(undefined) // 👈
      .required(`${e_municipaly.requiredErrorMsg}`),
    [e_address_company.name]: Yup.string().required(`${e_address_company.requiredErrorMsg}`),
    [e_workplace.name]: Yup.object()
      .shape({
        value: Yup.string().required(),
        label: Yup.string().required(),
      })
      .default(undefined) // 👈
      .required(`${e_workplace.requiredErrorMsg}`),
    [e_landline.name]: Yup.string().nullable(),
    [e_cell_phone.name]: Yup.string().required(`${e_tradename.requiredErrorMsg}`),
  }),

  // FORMA DE PAGO
  Yup.object().shape({
    [e_payment_frequency.name]: Yup.object()
      .shape({
        value: Yup.string().required(),
        label: Yup.string().required(),
      })
      .default(undefined) // 👈
      .required(`${e_payment_frequency.requiredErrorMsg}`),
    [e_payment_method.name]: Yup.object()
      .shape({
        value: Yup.string().required(),
        label: Yup.string().required(),
      })
      .default(undefined) // 👈
      .required(`${e_payment_method.requiredErrorMsg}`),

    // [e_associated_bank.name]: Yup.object().shape({
    //   value: Yup.string().required(),
    //   label: Yup.string().required()
    // }).default(undefined) // 👈
    // .required(`${e_associated_bank.requiredErrorMsg}`),

    [e_associated_bank.name]: Yup.object()
      .shape({
        value: Yup.string(),
        label: Yup.string(),
      })
      .default(undefined)
      .when([e_payment_method.name], ([paymentMethod], schema) => {
        return paymentMethod?.label.toLowerCase() === 'efectivo'
          ? schema.notRequired()
          : schema
              .shape({
                value: Yup.string().required('Banco requerido'),
                label: Yup.string().required('Etiqueta requerida'),
              })
              .required(e_associated_bank.requiredErrorMsg);
      }),

    // [e_type_account_bank.name]: Yup.object().shape({
    //   value: Yup.string().required(),
    //   label: Yup.string().required()
    // }).default(undefined) // 👈
    // .required(`${e_type_account_bank.requiredErrorMsg}`),

    [e_type_account_bank.name]: Yup.object()
      .shape({
        value: Yup.string(),
        label: Yup.string(),
      })
      .default(undefined)
      .when([e_payment_method.name], ([paymentMethod], schema) => {
        return paymentMethod?.label.toLowerCase() === 'efectivo'
          ? schema.notRequired()
          : schema
              .shape({
                value: Yup.string().required('Tipo cuenta requerida'),
                label: Yup.string().required('Etiqueta requerida'),
              })
              .required(`${e_type_account_bank.requiredErrorMsg}`);
      }),

    [e_account_number.name]: Yup.string()
      .default(undefined)
      .when([e_payment_method.name], ([paymentMethod], schema) => {
        return paymentMethod?.label.toLowerCase() === 'efectivo'
          ? schema.notRequired()
          : schema.required(`${e_type_account_bank.requiredErrorMsg}`);
      }),

    // [e_account_number.name]: Yup.string().required(`${e_account_number.requiredErrorMsg}`)
  }),

  // ARCHIVO
  Yup.object().shape({
    [e_rut.name]: Yup.string().required(`${e_rut.requiredErrorMsg}`),
    // [e_chamber_of_commerce.name]: Yup.string().required(`${e_chamber_of_commerce.requiredErrorMsg}`),
    // [bank_certificate.name]: Yup.string().required(`${bank_certificate.requiredErrorMsg}`)
    [e_bank_certificate.name]: Yup.string()
      .default(undefined)
      .when([e_payment_method.name], ([paymentMethod], schema) => {
        return paymentMethod?.label.toLowerCase() === 'efectivo'
          ? schema.notRequired()
          : schema.required(`${e_bank_certificate.requiredErrorMsg}`);
      }),
  }),

  // SEGURIDAD SOCIAL
  Yup.object().shape({
    [e_sgsst.name]: Yup.object()
      .shape({
        value: Yup.string().required(),
        label: Yup.string().required(),
      })
      .default(undefined) // 👈
      .required(`${e_sgsst.requiredErrorMsg}`),
    [e_arl.name]: Yup.object()
      .shape({
        value: Yup.string().required(),
        label: Yup.string().required(),
      })
      .default(undefined) // 👈
      .required(`${e_arl.requiredErrorMsg}`),
    [e_constitution_date.name]: Yup.string().required(`${e_constitution_date.requiredErrorMsg}`),
    [e_ley_1429_2010.name]: Yup.boolean(),
    [e_ley_590_2000.name]: Yup.boolean(),
    [e_ley_1607_2012.name]: Yup.boolean(),
  }),
];
